export const meta = {
  title: 'Privacy Policy | gridcraft',
  description:
    'How gridcraft handles browsing information, support requests, cookies and links to third-party downloads.',
  updated_at: '2026-10-18',
};

## About this website

gridcraft (gridcraft.me) is an independent resource for GridCraft downloads, installation guides, comparisons with Microsoft Excel, and practical usage experiences. This policy covers this website and our support correspondence. Contact: [support@gridcraft.me](mailto:support@gridcraft.me).

## Information we process

- **Browsing information:** requests to the website may include your IP address, browser and device details, requested pages, referral information and timestamps. This information helps deliver pages, diagnose errors and prevent abuse.
- **Support requests:** when you email us, we receive your email address, message and any attachments you choose to provide. We use these to respond and investigate the issue.
- **Account features:** if you use an available sign-in or support feature, we process the information you submit and the session information needed to provide it.

Please remove passwords, license keys, personal records and confidential spreadsheet data before sending screenshots or files to support.

## Cookies and browser storage

The website uses cookies or browser storage where needed for features such as language preferences and sign-in sessions. You can manage cookies and site data in your browser; blocking them may affect these features. Any enabled analytics tools may process page views, device details and interactions to help us understand site usage. Optional tracking should follow your applicable consent settings.

## Downloads, external links and the editor

Download links may take you to software publishers or other third-party platforms. Those services handle information under their own privacy policies. The software you install is also subject to its publisher's terms and privacy practices.

If you use the embedded spreadsheet editor, its handling of files depends on the bundled software and the features you use. Do not assume that every operation is offline or that files have a cloud backup. Keep a separate copy of important workbooks.

## Use and sharing

We use information to operate and secure the website, answer support requests and improve our guides. Hosting, email and any enabled analytics providers may process information needed for these tasks. We do not sell your personal information. Information may also be disclosed when required by applicable law or to address abuse.

## Retention and security

We retain information only as needed for the purposes described here, including support, security and applicable recordkeeping obligations. Retention depends on the information and relevant service providers. We take reasonable measures to protect information, but cannot guarantee absolute security.

## Your choices

You can manage browser storage, stop using optional features, or email us to request access to, correction of or deletion of your information. We may need to verify your identity. We handle requests according to applicable requirements, including any records we must retain. Please do not send identity documents unless specifically requested through an agreed secure method.

## Children and updates

This website is intended for a general audience and does not knowingly request personal information from children. A parent or guardian can contact us about information a child has submitted. We may update this policy as the website changes; the revision date appears above.

## Contact

Privacy questions and requests: [support@gridcraft.me](mailto:support@gridcraft.me).
